import { render, staticRenderFns } from "./TracesMobile.vue?vue&type=template&id=47a1da61&"
import script from "./TracesMobile.vue?vue&type=script&lang=js&"
export * from "./TracesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports